<template>
    <website-page>
        <restauration-navigation></restauration-navigation>

        <div class="main-section overlay">
            <b-container>
                <br>

                <h1 class="blured" v-tr>
                    Menus Demonstrations|Démonstrations de menus
                </h1>
                <h2 class="subtitle blured" v-tr>
                    Test Self-Order with the QR Code below, your card won't be charged|Vous pouvez tester la commande autonome via le code QR ci-dessous, votre carte ne sera pas débitée
                </h2>

                <div>
                    <b-img width="200" :src="require('../../assets/img/qr-codes/food-force-tcby-demo.png')" alt="QR Code TCBY Demo Menu"></b-img>
                </div>

                <p class="presentation" v-tr></p>

                <div class="mt-5">
                    <b-btn v-scroll-to="'#contact-us'" class="mr-2" variant="primary"><span v-tr>Contact Us|Contactez-nous</span></b-btn>
                    <b-btn v-if="!isMobileLayout" v-scroll-to="'#mev-srm'" variant="outline-light"><span v-tr>Videos|Vidéos</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="mev-srm" class="page inverted">
            <b-container>
                <h3 class="text-center mb-5" v-tr>
                    Digital Menuboard Videos|Vidéos de menus numérique
                </h3>

                <b-row>
                    <b-col cols="12" md="6" lg="4">
                        <youtube-player iframe-src="https://www.youtube.com/embed/YFGh2CxHtLU" :poster="require('../../assets/img/video-splash/menu-creation-thumbnail.jpg')">
                            <h4 v-tr>Designing a Cloud Based Menu (2min)|Conception d'un menu "Cloud Based" (2min)</h4>
                            <p v-tr>
                                Discover how easy it is to design a Digital Menu Board for 2 full HD TVs, with our Storyboard Infinite HTML5 software.|
                                Découvrez à quel point il est facile de concevoir un menu numérique pour 2 téléviseurs Full HD, avec notre logiciel HTML5 Storyboard Infinite.
                            </p>
                        </youtube-player>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <youtube-player iframe-src="https://www.youtube.com/embed/xAQkahG2qeA" :poster="require('../../assets/img/video-splash/overview-mc-donald.jpg')">
                            <h4 v-tr>Summary of what Eye-In production for McDonald's|Résumé de ce qu'Eye-In a produit pour McDonald's</h4>
                            <p v-tr>
                                Did you know that Eye-In was the first Digital Signage for McDonald's Canada? Here is an example of work we did for them.|
                                Saviez-vous que Eye-In était le premier affichage numérique pour McDonald's Canada? Voici un exemple de travail que nous avons fait pour eux.
                            </p>
                        </youtube-player>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <youtube-player iframe-src="https://www.youtube.com/embed/YucUjiLBTcE" :poster="require('../../assets/img/video-splash/mc-donald-thumbnail.jpg')">
                            <h4 v-tr>McDonald's Videowall for 3 screens|Mur vidéo pour 3 écrans McDonald</h4>
                            <p v-tr>
                                Overview of some content animated for McDonald's. Displaying on 3 portrait TVs at the same time thanks to our powerful Eye-Infinite Player.|
                                Aperçu de certains contenus animés pour McDonald's. Affichage sur 3 téléviseurs portrait en même temps grâce à notre puissant lecteur Eye-Infinite.
                            </p>
                        </youtube-player>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <youtube-player iframe-src="https://www.youtube.com/embed/n5L-mmzaO6g" :poster="require('../../assets/img/video-splash/menu-thai-express-thumbnail.jpg')">
                            <h4 v-tr>Thai Express Menu with 4 animated screens|Thai Express Menu avec 4 écrans animés</h4>
                            <p v-tr>
                                A digital menu made for 4 Full HD TVs. Includes lots of animations made within our Storyboard Software, no videos, no code.|
                                Un menu numérique conçu pour 4 téléviseurs Full HD. Comprend de nombreuses animations réalisées dans notre logiciel Storyboard, aucune vidéo, aucun code.
                            </p>
                        </youtube-player>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <youtube-player iframe-src="https://www.youtube.com/embed/ttn9DrcIwsI" :poster="require('../../assets/img/video-splash/menu-cho-express-thumbnail.jpg')">
                            <h4 v-tr>Cho Express Menu with fullscreen content|Cho Express Menu avec contenu plein écran</h4>
                            <p v-tr>
                                A digital menu with 2 TVs for a restaurant with a videowall overlay that alternates after some time.|
                                Un menu numérique avec 2 téléviseurs pour un restaurant dont le contenu en plein écran apparaît après un certain temps.
                            </p>
                        </youtube-player>
                    </b-col>
                </b-row>

                <div v-if="!isMobileLayout" class="mt-4 text-center">
                    <b-btn v-scroll-to="'#contact-us'" variant="outline-light"><span v-tr>Contact Us|Nous contacter</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>
    </website-page>
</template>

<script>
    import RestaurationNavigation from "@/navigation/restauration-navigation.vue";
    import {translate} from "../../../vue-components/helpers/i18n.js";

    export default {
        name: `demonstrations`,
        components: {RestaurationNavigation},
        metaInfo: {
            title: translate(`Digital Signage Demonstrations|Démonstrations d'affichage numérique`),
            meta: [
                { name: `keywords`, content: `menu board, menuboard, storyboard infinite, digital menuboards, digital, signage, restaurants, bars, fast-foods, menus, dynamic, smart, schedule, advertising` },
                { name: `description`, content: translate(`Discover example of powerful digital signage designed specifically for restaurants|Découvrez un exemple d'affichage numérique puissant conçu spécifiquement pour les restaurants`) }
            ]
        }
    }
</script>

<style lang="scss" scoped>
.main-section {
    background-color: #151e28;
    background-image: url('../../assets/img/backgrounds/restaurant-inside.jpg');
    //background-image: url('../../assets/img/backgrounds/gdpr.webp');
    background-size: cover;
}
</style>
